import { render, staticRenderFns } from "./CompassCompetitors.vue?vue&type=template&id=5832bc96&scoped=true&"
import script from "./CompassCompetitors.vue?vue&type=script&lang=ts&"
export * from "./CompassCompetitors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5832bc96",
  null
  
)

export default component.exports